<template>
  <page-wrapper title="เพิ่ม package (สำหรับการซื้อนอกระบบ)">
    <confirm-dialog
      v-if="confirmSave.isShow"
      :data="confirmSave"
      @confirm="handleConfirmSave"
    />
    <div class="pt-1 offline-purchase">
      <loading-overlay :active="isLoading" />
      <div class="row">
        <div class="col-lg-2 col-sm-12">
          <p>ชื่อผู้ใช้</p>
          <el-select
            v-model="selectedUser"
            :remote-method="searchUser"
            :loading="loadingUser"
            class="w-100"
            value-key="user_id"
            filterable
            remote
          >
            <el-option
              v-for="item in searchUserResult"
              :key="item.id"
              :label="item.label"
              :value="item"
            ></el-option>
          </el-select>
        </div>
        <div class="col-lg-2 col-sm-12">
          <p>บ้านเลขที่</p>
          <el-select
            v-model="selectedHome"
            :remote-method="searchHome"
            :loading="loadingHome"
            value-key="homeId"
            class="w-100"
            filterable
            remote
          >
            <el-option
              v-for="(item, indexHome) in searchHomeResult"
              :key="indexHome"
              :label="item.label"
              :value="item"
              class="home-option"
            >
              <p class="title">{{ item.title }}</p>
              <p class="subtitle">{{ item.subtitle }}</p>
            </el-option>
          </el-select>
        </div>
        <div class="col-lg-8 col-sm-12">
          <p>แพ็กเกจ</p>
          <el-select
            v-model="selectedPackage"
            :remote-method="handleRemoteMethod"
            value-key="id"
            class="w-100"
            filterable
            clearable
            remote
          >
            <el-option
              v-for="item in packages"
              :key="item.id"
              :label="item.name"
              :value="item"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div v-if="packageDetail" class="row mt-4">
        <div class="col-lg-2 col-sm-12">
          <div v-if="user" class="user-detail">
            <p>ชื่อ</p>
            <div class="mb-2">{{ user.firstName }}</div>
            <p>นามสกุล</p>
            <div class="mb-2">{{ user.lastName }}</div>
            <p>เพศ</p>
            <div class="mb-2">{{ user.gender }}</div>
            <p>วันเกิด</p>
            <div class="mb-2">{{ user.birthDate }}</div>
            <p>บัตรประชาชน / Passport</p>
            <div class="mb-2">{{ user.identifierId }}</div>
            <p>เบอร์โทรศัพท์</p>
            <div class="mb-2">{{ user.phoneNumber }}</div>
            <p>อีเมล</p>
            <div class="mb-2">{{ user.email }}</div>
            <p>สถานะ</p>
            <div class="mb-2">{{ user.status }}</div>
          </div>
        </div>
        <div class="col-lg-2 col-sm-12">
          <div v-if="home" class="home-detail">
            <p>บ้านเลขที่</p>
            <div class="mb-2">{{ home.addressNo }}</div>
            <p>โครงการ</p>
            <div class="mb-2">{{ home.projectName }}</div>
          </div>
        </div>
        <div class="col-lg-8 col-sm-12">
          <div v-if="pack" class="package-detail">
            <div class="row mb-2">
              <div class="col-sm-12 col-lg-4">
                <img :src="pack.coverUrl" class="img-fluid d-block mb-2" />
              </div>
              <div class="col-sm-12 col-lg-8">
                <div class="mb-2">ชื่อ: {{ pack.name }}</div>
                <div class="mb-2">recurring: {{ pack.billingCycle }}</div>
                <div class="grid-incentive">
                  <div>
                    <p>วันที่ซื้อ (วันที่ซื้อ = วันที่ชำระ)</p>
                    <el-date-picker v-model="datePurchase" />
                  </div>
                  <div>
                    <p>Incentive</p>
                    <el-input v-model="incentive" type="text" />
                  </div>
                </div>
              </div>
            </div>
            <service-option-offline-purchase
              v-model="packageOptionDetail"
              :data="pack"
              :coupon="coupon"
              @selectCoupon="handleChangeCoupon"
            ></service-option-offline-purchase>
            <p class="mt-4">โครงการที่รองรับ</p>
            <div class="mb-2 project">
              <p v-for="(project, index) in pack.projects" :key="index">
                {{ project.name }}
              </p>
            </div>
            <bank-select
              v-if="!isRJB2BPackage"
              v-model="bankInformation"
              :total-price="packageOptionDetail.totalPrice"
              :icon-url="iconUrl"
            ></bank-select>
          </div>
        </div>
      </div>
      <div v-if="showUnsupportedAlert" class="text-end mt-4 text-danger">
        Package นี้ไม่รองรับโครงการของบ้านที่เลือก
      </div>
      <div v-if="packageDetail" class="mt-4 text-end">
        <sc-button
          :disabled="isLoading"
          variant="primary"
          @click="handleClickSave"
          >บันทึก</sc-button
        >
      </div>
      <div>
        <confirm-dialog v-show="isAddingHome" :data="addHomeConfirm">
          <add-home v-model="addHomeForm"></add-home>
          <div class="text-end">
            <sc-button class="me-2" @click="handleCancelAddHome"
              >ยกเลิก</sc-button
            >
            <sc-button variant="primary" @click="handleSaveAddHome"
              >บันทึก</sc-button
            >
          </div>
        </confirm-dialog>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import { Select, Option, DatePicker, Input } from "element-ui";
import { DateTime } from "luxon";
import { uploadPublicImage } from "@/god"
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import LoadingOverlay from "@/lib/components/LoadingOverlay";
import { baanRueJaiClient } from "@/dependencies";
import { userRoleMapper, genderMapper } from "@/lib/mapper";
import { toLocaleTH } from "@/lib/dateTime";
import { toCamelCaseObject } from "@/lib/util";
import ConfirmDialog from "@/components/helper/dialog/ConfirmDialog";
import {
  convertBathToStangAndRoundTwoDecimal,
  convertPriceStringToInt,
  convertStangToBathAndRoundTwoDecimal,
  formatCurrencyAndTwoDecimalsString,
} from "@/lib/formatter"
import ServiceOptionOfflinePurchase from "../components/ServiceOptionOfflinePurchase";
import AddHome from "../../../../managements/modules/users/components/AddHome"
import BankSelect from "../components/BankSelect";

export default {
  components: {
    ConfirmDialog,
    PageWrapper,
    ScButton,
    LoadingOverlay,
    "el-select": Select,
    "el-option": Option,
    "el-date-picker": DatePicker,
    "el-input": Input,
    ServiceOptionOfflinePurchase,
    BankSelect,
    AddHome,
  },
  data() {
    const bankInformation = {
      bankName: "ธนาคารไทยพานิชย์",
      bankId: "111-225-3008",
      slipAmount: null,
      iconFile: null,
      bankNote: null,
      sellerTradePartyIdByPackage: null,
      channel: null,
      actualPrice: null,
    }

    const packageOptionDetail = {
      packageOptions: [],
      packagePrice: null,
      quality: 1,
      discountAmount: null,
      totalPrice: null,
      mainOptionSelected: [],
      extraOptionSelected: [],
      isWithholding: false,
      totalPriceWithholding: null,
      canUseCoupon: true,
    }

    const addHomeForm = {
      project: null,
      homes: [],
      role: null,
    }

    const addHomeConfirm = {
      title: "เพิ่มผู้ใช้เข้าบ้าน",
    }

    return {
      selectedUser: null,
      selectedHome: null,
      selectedPackage: null,
      loadingUser: false,
      searchUserResult: [],
      searchHomeResult: [],
      packages: [],
      packageDetail: null,
      bankInformation,
      packageGroups: null,
      iconUrl: null,
      datePurchase: null,
      incentive: null,
      coupon: null,
      packageOptionDetail,
      addHomeToUser: "addHomeToUser",
      addHomeForm,
      isAddingHome: false,
      addHomeConfirm,
      isLoading: false,
      filterHome: [],
      loadingHome: false,
      homeUniqueList: null,
      confirmSave: {
        isShow: false,
        title: 'กรุณาตรวจสอบความถูกต้องทั้งหมด เนื่องจากมีผลกับทางบัญชี',
        buttonSubmit: 'ยืนยัน',
        buttonCancel: 'ยกเลิก',
      },
    }
  },
  computed: {
    user() {
      if (this.selectedUser === null) {
        return null
      }

      const user = this.selectedUser.user
        ? this.selectedUser.user
        : this.selectedUser

      const { user_profile: userProfile, email } = user
      const {
        first_name: firstName,
        last_name: lastName,
        gender: genderEnum,
        citizen_id: citizenId,
        passport_number: passportNumber,
        birth_date: birthDate,
        mobile_number: mobileNumber,
      } = userProfile
      const identifierId = citizenId || passportNumber || "-"
      const isVerified = identifierId !== "-"
      const gender = genderEnum ? genderMapper[genderEnum] : "-"
      const birthDateFormatted = birthDate
        ? toLocaleTH(DateTime.fromISO(birthDate)).toFormat("dd MMMM yyyy")
        : "-"
      const phoneNumber = mobileNumber || "-"
      const status = isVerified ? "ยืนยันตัวตนแล้ว" : "ยังไม่ยืนยันตัวตน"

      return {
        firstName,
        lastName,
        gender,
        birthDate: birthDateFormatted,
        identifierId,
        phoneNumber,
        status,
        isVerified,
        email,
      }
    },
    home() {
      if (!this.selectedHome) {
        return null
      }

      const { addressNo } = this.selectedHome
      const projectName = `${this.selectedHome.projectName} (${this.selectedHome.projectCode})`

      return {
        addressNo,
        projectName,
      }
    },
    pack() {
      if (!this.selectedPackage) {
        return null
      }

      const { name } = this.selectedPackage
      const price = `${formatCurrencyAndTwoDecimalsString(this.selectedPackage.price / 100)} บาท`
      const billingCycle = `${this.selectedPackage.billing_cycle.toLocaleString()} เดือน`
      const coverUrl = this.selectedPackage.image_url
      const pack = {
        name,
        price,
        billingCycle,
        coverUrl,
      }

      if (!this.packageDetail) {
        return pack
      }

      const services = this.packageDetail.services.map((service) => {
        const {
          id,
          name: serviceName,
          short_description: shortDescription,
          description,
        } = service
        const provider = {
          ...service.provider,
          logoUrl: service.provider.logo_url,
        }

        return {
          id,
          name: serviceName,
          shortDescription,
          description,
          provider,
          servicePrices: null,
          mainOption: null,
          extraOption: null,
        }
      })

      const projects = this.packageDetail.projects.map((project) => ({
        id: project.project_code,
        name: `${project.project_code} - ${project.project_name}`,
      }))
      pack.services = services
      pack.projects = projects
      pack.packagePrice = convertBathToStangAndRoundTwoDecimal(
        this.selectedPackage.price,
      )
      pack.packageId = this.selectedPackage.id

      return pack
    },
    showUnsupportedAlert() {
      return (
        this.selectedHome &&
        this.selectedPackage &&
        !this.selectedPackage.project_ids.includes(this.selectedHome.projectId)
      )
    },
    isRJB2BPackage() {
      return this.packageGroups && this.packageGroups.includes("RJB2B")
    },
  },
  watch: {
    async selectedUser(val) {
      if (val === null) {
        this.searchUserResult = []
        this.homeId = null
        return
      }
      const userId = val.user ? val.user.user_id : val.user_id

      this.isLoading = true;
      await this.getUserDetail(userId);
      this.isLoading = false;
    },
    async selectedHome(newValue) {
      if (
        newValue &&
        newValue.homeId &&
        newValue.homeId === this.addHomeToUser
      ) {
        this.isAddingHome = true
        this.selectedHome = undefined
        return
      }

      if (!newValue) {
        this.searchHomeResult = []
        this.userId = null
        return
      }

      const homeId = newValue.home ? newValue.home.homeId : newValue.homeId
      const result = this.filterHome

      const homeResult = result
        .filter((user) => user.homes && user.homes.length)
        .flatMap((item) => {
          const { user } = item
          const { homes } = item

          return homes.map((h) => ({
            homeId: h.home_id,
            user,
          }))
        })

      const homeUserResult = homeResult.filter(
        (home) => home.homeId === homeId && !home.user,
      )
      if (homeUserResult.length === 0) {
        this.searchUserResult = []
      }

      this.searchUserResult = homeResult
        .filter((home) => home.homeId === homeId)
        .map((item) => {
          const user = item.user ? item.user : item

          return {
            ...user,
            label: `${user.user_profile.first_name} ${user.user_profile.last_name}`,
          }
        })
    },
    async selectedPackage(val) {
      this.packageDetail = null
      this.packageGroups = null

      if (!val) return

      const { id } = val
      this.isLoading = true;
      this.packageDetail = await this.fetchPackageDetail(id);
      this.isLoading = false;

      let packageOptions = []
      if (this.packageDetail.package_options) {
        packageOptions = this.packageDetail.package_options.map(
          (serviceOption, serviceOptionIndex) => {
            let serviceVariants
            if (
              serviceOption.service_option_variants &&
              serviceOption.service_option_variants.length > 0
            ) {
              serviceVariants = serviceOption.service_option_variants.map(
                (serviceVariant, serviceVariantIndex) => {
                  const variants = serviceVariant.variants.map((variant) => {
                    if (serviceVariantIndex === 0 && !variant.extra_option) {
                      this.packageOptionDetail.mainOptionSelected[
                        serviceOptionIndex
                      ] = {
                        isExtraOption: variant.extra_option,
                        price:
                          variant.price !== null
                            ? convertBathToStangAndRoundTwoDecimal(
                                variant.price,
                              )
                            : null,
                        title: variant.title,
                        id: variant.id,
                        isNotSale: variant.isNotSale,
                        serviceId: serviceOption.service_id,
                      }
                    }

                    return {
                      isExtraOption: variant.extra_option,
                      price:
                        variant.price !== null
                          ? convertBathToStangAndRoundTwoDecimal(variant.price)
                          : null,
                      title: variant.title,
                      id: variant.id,
                      isVariantSelected:
                        serviceVariantIndex === 0 && !variant.extra_option,
                      isNotSale: variant.is_not_sale,
                    }
                  })

                  return {
                    title: serviceVariant.title,
                    id: serviceVariant.id,
                    variants,
                  }
                },
              )
            }

            return {
              serviceTitle: serviceOption.service_title,
              serviceId: serviceOption.service_id,
              isNotSale: serviceOption.is_not_sale,
              servicePrice:
                serviceOption.service_price !== null
                  ? convertBathToStangAndRoundTwoDecimal(
                      serviceOption.service_price,
                    )
                  : null,
              serviceVariants,
            }
          },
        )
      }

      this.packageOptionDetail = {
        ...this.packageOptionDetail,
        packageOptions,
        isWithholding: null,
        totalPriceWithholding: null,
      }

      this.bankInformation = {
        ...this.bankInformation,
        bankName: null,
        bankId: null,
        bankNote: null,
        sellerTradePartyIdByPackage: null,
        channel: null,
      }

      this.packageGroups = this.packageDetail.package_groups
    },
    bankInformation(form, oldForm) {
      if (this.bankInformation.iconFile === oldForm.iconFile) {
        return
      }

      this.iconUrl = URL.createObjectURL(this.bankInformation.iconFile)
    },
    packageOptionDetail(form, oldForm) {
      if (form.isWithholding === true) {
        this.bankInformation.bankNote = "มีหัก ณ ที่จ่าย"
      } else if (
        form.isWithholding === false &&
        oldForm.isWithholding === true
      ) {
        this.bankInformation.bankNote = ""
      }
    },
  },
  created() {
    this.setup()
  },
  methods: {
    setup() {
      this.setupData()
    },
    setupData() {
      this.setupPackages()
    },
    async setupPackages() {
      this.isLoading = true;
      const result = await this.fetchPackages();

      this.packages = result;
      this.isLoading = false;
    },
    async searchUser(query) {
      this.loadingUser = true

      const [firstName, lastName, ...rest] = query.split(" ")
      const params = {
        firstName: firstName.trim(),
        lastName: lastName ? `${lastName} ${rest.join(" ")}`.trim() : undefined,
      }

      const result = await this.fetchUser(params)

      this.searchUserResult = result.users.map((item) => {
        const user = item.user ? item.user : item

        return {
          ...user,
          label: `${user.user_profile.first_name} ${user.user_profile.last_name}`,
        }
      })

      this.loadingUser = false
    },
    async searchHome(queryString) {
      this.loadingHome = true
      const query = {
        text_search: "",
        project_home_search: queryString,
        take: 30,
        is_filter_without_deleted_user_home: true,
        user_id:
          this.selectedUser && this.selectedUser.user_id
            ? +this.selectedUser.user_id
            : undefined,
      }

      const response = await baanRueJaiClient.admin.users.search(query)
      const { users } = response.data.result
      const search = users
        .filter((user) => user.homes && user.homes.length > 0)
        .flat()

      const homesSearchList = search.flatMap((item) => {
        const { homes } = item

        return homes
          .filter((home) => home.address_no !== "")
          .map((h) => {
            const camelCaseHome = toCamelCaseObject(h)
            const { addressNo, projectCode, projectName } = camelCaseHome

            const title = `บ้านเลขที่ ${addressNo}`
            const subtitle = `${projectCode} ${projectName}`
            const label = `${title} (${projectCode})`

            return {
              ...camelCaseHome,
              title,
              subtitle,
              label,
            }
          })
      })

      const homeUniqueList = homesSearchList
        ? this.getUniqueListBy(homesSearchList, "homeId")
        : null
      this.filterHome = search
      this.searchHomeResult = homeUniqueList
      this.loadingHome = false
    },
    async fetchUser(query) {
      const response = await baanRueJaiClient.admin.users.list(query)

      return response.data.result
    },
    async fetchUserDetail(userId) {
      const response = await baanRueJaiClient.admin.users.get(userId)

      return response.data.result
    },
    async fetchPackages() {
      const response =
        await baanRueJaiClient.admin.subscriptions.recommend_packages.list({
          filterlifestyle: false,
        })

      return response.data.result.packages
    },
    async fetchPackageDetail(id) {
      const response =
        await baanRueJaiClient.admin.subscriptions.recommend_packages.get(id)

      return response.data.result
    },
    async handleRemoteMethod(queryString) {
      // หาครั้งแรกว่ามีอีกกี่ package
      const firstPackagePage =
        await baanRueJaiClient.admin.subscriptions.recommend_packages.list({
          name: queryString,
          filterlifestyle: false,
          page: 1,
        })
      const responseFirstPackage = firstPackagePage.data.result.packages
      this.packages = responseFirstPackage

      const responseFirstPackageCount = firstPackagePage.data.result.count

      const countLeftPackage =
        responseFirstPackageCount && +responseFirstPackageCount > 10
          ? +responseFirstPackageCount - 10
          : undefined

      if (countLeftPackage && queryString) {
        const limitTake =
          countLeftPackage && countLeftPackage > 60 ? 60 : countLeftPackage

        const response =
          await baanRueJaiClient.admin.subscriptions.recommend_packages.list({
            name: queryString,
            filterlifestyle: false,
            page: 2,
            take: limitTake,
          })
        const responseLeftPackages = response.data.result.packages

        const allPackages = this.packages.concat(responseLeftPackages)
        this.packages = allPackages
      }
    },
    checkExistValueToAlertMassage(value, massageToAlert) {
      const massage = massageToAlert || "ไม่สามารถบันทึกข้อมูลได้"
      if (!value || value.length === 0) {
        this.$message.error(massage)
        this.isLoading = false
        return false
      }
      return true
    },
    handleClickSave() {
      this.confirmSave.isShow = true
    },
    handleConfirmSave(confirmed) {
      this.confirmSave.isShow = false
      if (confirmed) this.executeSave()
    },
    async executeSave() {
      this.isLoading = true

      if (
        !this.checkExistValueToAlertMassage(
          this.selectedUser.user_id,
          "กรุณาเลือก ผู้ใช้",
        )
      )
        return

      if (
        !this.checkExistValueToAlertMassage(
          this.selectedHome.homeId,
          "กรุณาเลือก บ้านเลขที่",
        )
      )
        return

      if (
        !this.checkExistValueToAlertMassage(
          this.selectedPackage.id,
          "กรุณาเลือก แพ็กเกจ",
        )
      )
        return

      if (
        !this.checkExistValueToAlertMassage(
          this.datePurchase,
          "กรุณาเลือก วันที่ซื้อ",
        )
      )
        return

      if (
        !this.checkExistValueToAlertMassage(
          this.incentive,
          "กรุณาเลือก Incentive",
        )
      )
        return

      if (
        !this.checkExistValueToAlertMassage(
          this.packageOptionDetail.quality,
          "กรุณาเลือก จำนวนการซื้อแพ็คเกจ",
        )
      )
        return

      if (!this.isRJB2BPackage) {
        if (
          !this.checkExistValueToAlertMassage(
            this.bankInformation.sellerTradePartyIdByPackage,
            "กรุณาเลือก ธนาคารที่โอน",
          )
        )
          return

        if (
          !this.checkExistValueToAlertMassage(
            this.bankInformation.iconFile,
            "กรุณาเลือก หลักฐานการโอน",
          )
        )
          return

        if (
          !this.checkExistValueToAlertMassage(
            this.bankInformation.sellerTradePartyIdByPackage,
            "กรุณาเลือก ผู้จัดหาบริการ",
          )
        )
          return

        if (
          !this.checkExistValueToAlertMassage(
            this.bankInformation.bankName && this.bankInformation.bankId,
            "กรุณาเลือก ธนาคารที่โอน",
          )
        )
          return

        if (
          !this.checkExistValueToAlertMassage(
            this.bankInformation.channel,
            "กรุณาเลือก วิธีการรับเงิน",
          )
        )
          return

        if (
          !this.checkExistValueToAlertMassage(
            this.bankInformation.slipAmount,
            "กรุณาเพิ่ม จำนวนเงินที่โอน",
          )
        )
          return
      }

      const packagePriceDetail = {}
      packagePriceDetail.quantity = +this.packageOptionDetail.quality
      packagePriceDetail.price = convertPriceStringToInt(
        this.packageOptionDetail.packagePrice,
      )

      packagePriceDetail.services = this.packageOptionDetail.packageOptions.map(
        (serviceOption) => {
          const mainOptionSelected =
            this.packageOptionDetail.mainOptionSelected.find(
              (item) => item && item.serviceId === serviceOption.serviceId,
            ) || null

          const extraOptionSelected =
            this.packageOptionDetail.extraOptionSelected.filter(
              (item) => item && item.serviceId === serviceOption.serviceId,
            ) || null

          let mainOption = {}
          mainOption.price =
            mainOptionSelected &&
            mainOptionSelected.price !== null &&
            mainOptionSelected.price >= 0
              ? convertStangToBathAndRoundTwoDecimal(+mainOptionSelected.price)
              : null
          mainOption.variant_id = mainOptionSelected && mainOptionSelected.id
          mainOption.extra_option =
            mainOptionSelected &&
            extraOptionSelected.map((varaint) => ({
              variant_id: varaint.id,
              price: convertStangToBathAndRoundTwoDecimal(varaint.price),
            }))

          if (!mainOptionSelected) {
            mainOption = null
          }

          let sumOptionPrice
          if (mainOption && mainOption.price) {
            sumOptionPrice = convertBathToStangAndRoundTwoDecimal(
              +mainOption.price,
            )
            if (mainOption.extra_option) {
              const extraPrice = mainOption.extra_option.reduce(
                (a, b) => a + b.price,
                0,
              )
              sumOptionPrice += convertBathToStangAndRoundTwoDecimal(extraPrice)
            }
          }
          const price = sumOptionPrice || serviceOption.servicePrice

          return {
            service_id: serviceOption.serviceId,
            price: convertPriceStringToInt(price),
            main_option: mainOption,
          }
        },
      )

      let actualPrice
      if (this.bankInformation.actualPrice) {
        actualPrice = convertStangToBathAndRoundTwoDecimal(
          this.bankInformation.actualPrice,
        )
      } else if (this.packageOptionDetail.totalPriceWithholding) {
        actualPrice = convertStangToBathAndRoundTwoDecimal(
          this.packageOptionDetail.totalPriceWithholding,
        )
      } else if (this.isRJB2BPackage) {
        actualPrice = undefined
      } else {
        actualPrice = convertStangToBathAndRoundTwoDecimal(
          this.packageOptionDetail.totalPrice,
        )
      }

      const isWithholdingTax = !!this.packageOptionDetail.totalPriceWithholding

      if (!actualPrice && actualPrice !== 0 && !this.isRJB2BPackage) {
        this.$message.error(
          "ไม่สามารถบันทึกได้ เพราะไม่มีราคาที่ลูกค้าจ่ายจริง",
        )
        return
      }

      const env = process.env.DEPLOY_ENV
        ? process.env.DEPLOY_ENV
        : process.env.NODE_ENV
      const imageUrl =
        this.bankInformation.iconFile && env !== "local"
          ? await uploadPublicImage(this.bankInformation.iconFile)
          : undefined
      const note = this.isRJB2BPackage
        ? "RM ระบุ ““"
        : this.bankInformation.bankNote || undefined
      const channel = this.isRJB2BPackage
        ? "RJB2B"
        : this.bankInformation.channel

      const params = {
        packageId: this.selectedPackage.id,
        homeId: this.selectedHome.homeId,
        projectId: this.selectedHome.projectId,
        userId: this.selectedUser.user_id,
        couponCode: (this.coupon && this.coupon.code) || undefined,
        note,
        receiptImage: imageUrl,
        accountNumberBank: this.bankInformation.bankId || undefined,
        accountNameBank: this.bankInformation.bankName || undefined,
        slipAmount:
          this.bankInformation.slipAmount !== null &&
          +this.bankInformation.slipAmount >= 0
            ? convertStangToBathAndRoundTwoDecimal(
                +this.bankInformation.slipAmount,
              )
            : undefined,
        packagePriceDetail,
        refCode: this.incentive,
        datePurchase: DateTime.fromJSDate(new Date(this.datePurchase))
          .startOf("day")
          .toUTC()
          .toISO(),
        actualPrice,
        isWithholdingTax,
        channel,
      }

      try {
        const response =
          await baanRueJaiClient.admin.subscriptions.subscribers.postOfflinePurchase(
            params,
          )

        if (
          response &&
          response.data &&
          response.data.result &&
          response.data.result.message &&
          response.data.result.message === "error"
        ) {
          this.$message.error(response.data.result.detail)
          this.isLoading = false
        } else {
          this.isLoading = false
          this.$router.push({ name: "SubscriberListPage" })
        }
      } catch (error) {
        this.$message.error(error.response?.data ?? error.message)
        this.isLoading = false
      }
    },
    handleChangeCoupon(coupon) {
      this.coupon = coupon
    },
    handleCancelAddHome() {
      this.isAddingHome = false

      this.addHomeForm = {
        project: null,
        homes: [],
        role: null,
      }
    },
    async handleSaveAddHome() {
      this.isAddingHome = false

      try {
        await this.inviteUserToHome()
      } catch (error) {
        this.$message.error("ไม่สามารถเพิ่มผู้ใช้เข้าบ้านได้")
      }

      this.addHomeForm = { homes: [], project: null, role: null }
    },
    async inviteUserToHome() {
      const { project, homes, role } = this.addHomeForm
      if (!project) {
        this.$message.error("กรุณาเลือกโครงการ")
        return
      }
      const homeIds = homes.map(({ homeId }) => homeId)
      const { projectId } = project
      const params = {
        homeIds,
        projectId,
        role,
      }

      await baanRueJaiClient.admin.users.invite(
        this.selectedUser.user_id,
        params,
      )
      await this.getUserDetail(this.selectedUser.user_id)
    },
    async getUserDetail(userId) {
      const result = await this.fetchUserDetail(userId)

      const addHomeToUser = [
        {
          title: "+ เพิ่มลูกค้าเข้าบ้าน",
          homeId: this.addHomeToUser,
          label: undefined,
          subtitle: undefined,
        },
      ]

      if (!result.homes) {
        this.searchHomeResult = addHomeToUser
        return
      }

      const searchHomeDetail = result.homes
        .filter((home) => home.address_no !== "")
        .map((home) => {
          const camelCaseHome = toCamelCaseObject(home)
          const { addressNo, projectCode, projectName, userRole } =
            camelCaseHome
          const userRoleTH = userRoleMapper[userRole]

          const title = `${userRoleTH} บ้านเลขที่ ${addressNo}`
          const subtitle = `${projectCode} ${projectName}`
          const label = `${title} (${projectCode})`

          return {
            ...camelCaseHome,
            title,
            subtitle,
            label,
          }
        })

      this.searchHomeResult = addHomeToUser.concat(searchHomeDetail)
    },
    getUniqueListBy(array, key) {
      return [...new Map(array.map((item) => [item[key], item])).values()]
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.home-option {
  padding-top: 10px;
  padding-bottom: 10px;
  height: auto;

  > .title,
  > .subtitle {
    margin: 0;
  }

  > .title {
    font-size: 14px;
    font-weight: normal;
  }

  > .subtitle {
    font-size: 12px;
  }
}

.offline-purchase {
  padding-left: 10px;
  padding-right: 10px;
}

.service-option {
  border: $border-head;
  height: 50px;
  padding: 10px;
  background: #f2f2f2;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.project {
  width: auto;
  max-height: 400px;
  overflow-x: auto;
}

.grid-incentive {
  display: grid;
  grid-template-columns: 250px 120px;
}
</style>
